import React from 'react';
import ButtonDesigned from '../../../../../../components/UI-Elements/Buttons/ButtonDesigned';

interface ButtonProps {
  onCloseDocument: () => void;
}

export const ContractButtonSection: React.FC<ButtonProps> = ({ onCloseDocument }) => {
  return (
    <div className="flex justify-end">
      <ButtonDesigned
        className="px-[1rem]"
        onButtonClick={() => {
          onCloseDocument();
        }}
        style="outline"
      >
        Closed
      </ButtonDesigned>
    </div>
  );
};
